// auth/super-admin.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { isSuperAdmin as isSuperAdminUser, Logger, User } from 'shared';

export const superAdminGuard: CanActivateFn = (route, state) => {
  const authService: AuthService = inject(AuthService);
  const router: Router = inject(Router);
  const logger = new Logger('superAdminGuard: CanActivateFn');

  return authService.getUser$().pipe(
    take(1),
    map((user: User | null) => {
      if (!user) {
        logger.debug(`NOT LOGGED IN => CANNOT ACTIVATE: ${route.url}. PERFORM NAVIGATION TO /login`);
        router.navigate(['/login']);
        return false;
      }

      const isSuperAdmin = isSuperAdminUser(user);
      if (isSuperAdmin) {
        logger.debug(`SUPER ADMIN USER => CAN ACTIVATE: ${route.url}`);
        return true;
      }

      logger.warn(`NON-SUPER-ADMIN USER => CANNOT ACTIVATE: ${route.url}. PERFORM NAVIGATION TO /en`);
      router.navigate(['/en']);
      return false;
    })
  );
};
